if (typeof jQuery !== "undefined") {
  jQuery.fn.airdatepicker.language["en"] = {
    days: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    monthsShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    today: "Today",
    clear: "Clear",
    dateFormat: "mm/dd/yyyy",
    timeFormat: "hh:ii aa",
    firstDay: 0,
  };

  const dayInMillis = 86400000;

  jQuery(document).ready(() => {
    let bookingContainers = document.querySelectorAll(".booking-widget");

    bookingContainers.forEach((bookingContainer) => {
      const bookNowButton = bookingContainer.querySelector(
        ".booking-widget--book a"
      );
      const mappings = JSON.parse(
        bookingContainer.querySelector(".booking-widget-mappings").innerHTML
      );

      const hotelDropdown = bookingContainer.querySelector(
        ".booking-widget--options-hotel"
      );
      const peopleDropdown = bookingContainer.querySelector(
        ".booking-widget--options-people"
      );

      const monthsShort = jQuery.fn.airdatepicker.language["en"].monthsShort;
      const nightsTarget = bookingContainer.querySelector(
        ".booking-widget--nights-value"
      );

      const startDate = bookingContainer.querySelector(
        ".booking-widget--arrive-selector input"
      );
      const endDate = bookingContainer.querySelector(
        ".booking-widget--leave-selector input"
      );

      let hotelChoices = null;
      let peopleChoices = null;

      let hotelDropdownOpen = false;
      let peopleDropdownOpen = false;

      let days = null;

      const updateDays = (source) => {
        const start = new Date(startDate.value);
        const end = new Date(endDate.value);

        days = Math.floor((end - start) / 8.64e7);
        let sourceRole = source.getAttribute("data-date-role");

        if (days <= 0) {
          days = 1;
          if (sourceRole !== "start") {
            jQuery(startDate)
              .data("datepicker")
              .selectDate(new Date(end.getTime() - dayInMillis));
          } else {
            jQuery(endDate)
              .data("datepicker")
              .selectDate(new Date(start.getTime() + dayInMillis));
          }
        }

        nightsTarget.querySelector("p").innerHTML =
          days + (days == 1 ? " night" : " nights");
        updateBookingTarget();
      };

      const updateBookingTarget = () => {
        let hotelID;
        let people = peopleChoices.getValue().value;
        let arriveDate = new Date(startDate.value);
        let departDate = new Date(endDate.value);

        if (hotelChoices) {
          hotelID = hotelChoices.getValue().value;
        } else {
          hotelID = bookingContainer.querySelector(
            'input[name="bookingHotelID"]'
          ).value;
        }

        if (hotelID) {
          let url = mappings[hotelID];
          let formattedStart = "";
          let formattedEnd = "";

          if (url.indexOf("travelclick.com") !== -1) {
            formattedStart =
              arriveDate.getMonth() +
              1 +
              "/" +
              arriveDate.getDate() +
              "/" +
              arriveDate.getFullYear();
            formattedEnd =
              departDate.getMonth() +
              1 +
              "/" +
              departDate.getDate() +
              "/" +
              departDate.getFullYear();
          } else {
            formattedStart =
              arriveDate.getFullYear() +
              "-" +
              (arriveDate.getMonth() + 1) +
              "-" +
              arriveDate.getDate();
            formattedEnd =
              departDate.getFullYear() +
              "-" +
              (departDate.getMonth() + 1) +
              "-" +
              departDate.getDate();
          }

          window.setOptimizeHotel(url);
          url = url
            .replace("{{guests}}", people)
            .replace("{{arrive}}", formattedStart)
            .replace("{{depart}}", formattedEnd)
            .replace(
              "{{promo}}",
              window.preDeterminedPromoCode ? window.preDeterminedPromoCode : ""
            )
            .replace(/&amp;/g, "&");

          // Don't do this until approved
          // if (days > 7 && hotelID == 11) {
          //   url =
          //     "https://www.dash.co/en/hong-kong/the-sheung-wan-by-dash-living/";
          // }

          window.updateBookingEngineLink(bookNowButton, url);
        }
      };

      if (hotelDropdown) {
        hotelChoices = new Choices(hotelDropdown, {
          searchEnabled: false,
          placeholder: false,
          shouldSort: false,
          itemSelectText: "",
        });

        hotelDropdown.addEventListener("change", (choice) => {
          if (choice.detail.value) {
            bookNowButton.removeAttribute("disabled");
            updateBookingTarget();
          } else {
            bookNowButton.setAttribute("disabled", "disabled");
          }
        });

        jQuery(hotelDropdown).mouseup(function () {
          hotelChoices.showDropdown();
          hotelDropdown.focus();
          hotelDropdownOpen = true;
        });

        jQuery(hotelDropdown).blur(function () {
          hotelChoices.hideDropdown();
          hotelDropdownOpen = false;
        });
      }

      peopleChoices = new Choices(peopleDropdown, {
        searchEnabled: false,
        placeholder: false,
        shouldSort: false,
        itemSelectText: "",
      });

      jQuery(peopleDropdown).mouseup(function () {
        peopleChoices.showDropdown();
        peopleDropdown.focus();
        peopleDropdownOpen = true;
      });

      jQuery(peopleDropdown).blur(function () {
        peopleChoices.hideDropdown();
        peopleDropdownOpen = false;
      });

      bookingContainer.addEventListener("mouseleave", () => {
        if (peopleDropdownOpen || hotelDropdownOpen) {
          document.activeElement.blur();
        }
      });

      peopleDropdown.addEventListener("change", updateBookingTarget);
      bookingContainer
        .querySelectorAll(".booking-datepicker")
        .forEach((datepicker) => {

          // Set common options for both arrive and depart date pickers
          let options = {
            language: "en",
            autoClose: true,
            minDate: new Date(),
            toggleSelected: false,
            date: new Date(),
            onSelect: (date, b, event) => {
              date = new Date(date);
              let dateToSet =
                monthsShort[date.getMonth()] + " " + date.getDate();
              jQuery(datepicker).closest("label").find("span").html(dateToSet);
              jQuery(datepicker).parent().removeClass("active");
              updateDays(event.el);
            },
          };

          // Set role-specific date picker options
          if (datepicker.getAttribute("name") === "startDate") {
            options.minDate = new Date();
          } else if (datepicker.getAttribute("name") === "endDate") {
            options.minDate = new Date(new Date().getTime() + dayInMillis);
          }
      
          jQuery(datepicker).airdatepicker(options);

          let day = new Date();
          if (datepicker.getAttribute("name") != "startDate") {
            day.setDate(day.getDate() + 1);
          }

          jQuery(datepicker).data("datepicker").selectDate(day);

          jQuery(datepicker)
            .mouseup(function () {
              datepicker.focus();
              jQuery(datepicker).parent().addClass("active");
            })
            .blur(function () {
              jQuery(datepicker).parent().removeClass("active");
            });
        });
    });
  });
}
